export const ADVANTAGES = [
  {
    title: 'Стабильный поток выручки ',
    notice: 'Фиксированная оплата за размещение формирует предсказуемый денежный поток',
  },
  {
    title: 'Гибкость',
    notice: 'Разные форматы и пакеты для разных сегментов клиентов',
  },
  {
    title: 'Масштабируемость',
    notice: 'Модель легко адаптируется под регионы и категории недвижимости',
  },
  {
    title: 'Контрцикличность',
    notice: 'При снижении спроса пользователи увеличивают срок экспозиции объектов, что сглаживает колебания рынка',
  },
  {
    title: 'Поддержка спроса',
    notice: 'Продвижение объектов стимулирует отклики и конверсию в сделки, усиливая общий доход',
  },
];
